/**
 * @fileoverview gRPC-Web generated client stub for pb
 * @enhanceable
 * @public
 */

// Code generated by protoc-gen-grpc-web. DO NOT EDIT.
// versions:
// 	protoc-gen-grpc-web v1.5.0
// 	protoc              v5.28.2
// source: krafty_service.proto


/* eslint-disable */
// @ts-nocheck



const grpc = {};
grpc.web = require('grpc-web');


var plant_pb = require('./plant_pb.js')

var upstream_pb = require('./upstream_pb.js')

var device_pb = require('./device_pb.js')

var template_pb = require('./template_pb.js')

var image_pb = require('./image_pb.js')

var worker_pb = require('./worker_pb.js')

var agent_state_pb = require('./agent_state_pb.js')

var user_pb = require('./user_pb.js')
const proto = {};
proto.pb = require('./krafty_service_pb.js');

/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.pb.KraftyServiceClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @param {string} hostname
 * @param {?Object} credentials
 * @param {?grpc.web.ClientOptions} options
 * @constructor
 * @struct
 * @final
 */
proto.pb.KraftyServicePromiseClient =
    function(hostname, credentials, options) {
  if (!options) options = {};
  options.format = 'text';

  /**
   * @private @const {!grpc.web.GrpcWebClientBase} The client
   */
  this.client_ = new grpc.web.GrpcWebClientBase(options);

  /**
   * @private @const {string} The hostname
   */
  this.hostname_ = hostname.replace(/\/+$/, '');

};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Device,
 *   !proto.pb.Device>}
 */
const methodDescriptor_KraftyService_FilterDevices = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/FilterDevices',
  grpc.web.MethodType.SERVER_STREAMING,
  device_pb.Device,
  device_pb.Device,
  /**
   * @param {!proto.pb.Device} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  device_pb.Device.deserializeBinary
);


/**
 * @param {!proto.pb.Device} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Device>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.filterDevices =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterDevices',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterDevices);
};


/**
 * @param {!proto.pb.Device} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Device>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServicePromiseClient.prototype.filterDevices =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterDevices',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterDevices);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Device,
 *   !proto.pb.Device>}
 */
const methodDescriptor_KraftyService_GetDevice = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/GetDevice',
  grpc.web.MethodType.UNARY,
  device_pb.Device,
  device_pb.Device,
  /**
   * @param {!proto.pb.Device} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  device_pb.Device.deserializeBinary
);


/**
 * @param {!proto.pb.Device} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Device)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Device>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.getDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/GetDevice',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetDevice,
      callback);
};


/**
 * @param {!proto.pb.Device} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Device>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.getDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/GetDevice',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Device,
 *   !proto.pb.Device>}
 */
const methodDescriptor_KraftyService_NewDevice = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/NewDevice',
  grpc.web.MethodType.UNARY,
  device_pb.Device,
  device_pb.Device,
  /**
   * @param {!proto.pb.Device} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  device_pb.Device.deserializeBinary
);


/**
 * @param {!proto.pb.Device} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Device)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Device>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.newDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/NewDevice',
      request,
      metadata || {},
      methodDescriptor_KraftyService_NewDevice,
      callback);
};


/**
 * @param {!proto.pb.Device} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Device>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.newDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/NewDevice',
      request,
      metadata || {},
      methodDescriptor_KraftyService_NewDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Device,
 *   !proto.pb.Device>}
 */
const methodDescriptor_KraftyService_UpdateDevice = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/UpdateDevice',
  grpc.web.MethodType.UNARY,
  device_pb.Device,
  device_pb.Device,
  /**
   * @param {!proto.pb.Device} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  device_pb.Device.deserializeBinary
);


/**
 * @param {!proto.pb.Device} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Device)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Device>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.updateDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/UpdateDevice',
      request,
      metadata || {},
      methodDescriptor_KraftyService_UpdateDevice,
      callback);
};


/**
 * @param {!proto.pb.Device} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Device>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.updateDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/UpdateDevice',
      request,
      metadata || {},
      methodDescriptor_KraftyService_UpdateDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Device,
 *   !proto.pb.Device>}
 */
const methodDescriptor_KraftyService_DeleteDevice = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/DeleteDevice',
  grpc.web.MethodType.UNARY,
  device_pb.Device,
  device_pb.Device,
  /**
   * @param {!proto.pb.Device} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  device_pb.Device.deserializeBinary
);


/**
 * @param {!proto.pb.Device} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Device)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Device>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.deleteDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/DeleteDevice',
      request,
      metadata || {},
      methodDescriptor_KraftyService_DeleteDevice,
      callback);
};


/**
 * @param {!proto.pb.Device} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Device>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.deleteDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/DeleteDevice',
      request,
      metadata || {},
      methodDescriptor_KraftyService_DeleteDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Device,
 *   !proto.pb.Device>}
 */
const methodDescriptor_KraftyService_ApproveDevice = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/ApproveDevice',
  grpc.web.MethodType.UNARY,
  device_pb.Device,
  device_pb.Device,
  /**
   * @param {!proto.pb.Device} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  device_pb.Device.deserializeBinary
);


/**
 * @param {!proto.pb.Device} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Device)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Device>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.approveDevice =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/ApproveDevice',
      request,
      metadata || {},
      methodDescriptor_KraftyService_ApproveDevice,
      callback);
};


/**
 * @param {!proto.pb.Device} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Device>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.approveDevice =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/ApproveDevice',
      request,
      metadata || {},
      methodDescriptor_KraftyService_ApproveDevice);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Template,
 *   !proto.pb.Template>}
 */
const methodDescriptor_KraftyService_FilterTemplates = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/FilterTemplates',
  grpc.web.MethodType.SERVER_STREAMING,
  template_pb.Template,
  template_pb.Template,
  /**
   * @param {!proto.pb.Template} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  template_pb.Template.deserializeBinary
);


/**
 * @param {!proto.pb.Template} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Template>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.filterTemplates =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterTemplates',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterTemplates);
};


/**
 * @param {!proto.pb.Template} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Template>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServicePromiseClient.prototype.filterTemplates =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterTemplates',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterTemplates);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Template,
 *   !proto.pb.Template>}
 */
const methodDescriptor_KraftyService_GetTemplate = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/GetTemplate',
  grpc.web.MethodType.UNARY,
  template_pb.Template,
  template_pb.Template,
  /**
   * @param {!proto.pb.Template} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  template_pb.Template.deserializeBinary
);


/**
 * @param {!proto.pb.Template} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Template)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Template>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.getTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/GetTemplate',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetTemplate,
      callback);
};


/**
 * @param {!proto.pb.Template} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Template>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.getTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/GetTemplate',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Template,
 *   !proto.pb.Template>}
 */
const methodDescriptor_KraftyService_NewTemplate = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/NewTemplate',
  grpc.web.MethodType.UNARY,
  template_pb.Template,
  template_pb.Template,
  /**
   * @param {!proto.pb.Template} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  template_pb.Template.deserializeBinary
);


/**
 * @param {!proto.pb.Template} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Template)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Template>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.newTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/NewTemplate',
      request,
      metadata || {},
      methodDescriptor_KraftyService_NewTemplate,
      callback);
};


/**
 * @param {!proto.pb.Template} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Template>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.newTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/NewTemplate',
      request,
      metadata || {},
      methodDescriptor_KraftyService_NewTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Template,
 *   !proto.pb.Template>}
 */
const methodDescriptor_KraftyService_UpdateTemplate = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/UpdateTemplate',
  grpc.web.MethodType.UNARY,
  template_pb.Template,
  template_pb.Template,
  /**
   * @param {!proto.pb.Template} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  template_pb.Template.deserializeBinary
);


/**
 * @param {!proto.pb.Template} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Template)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Template>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.updateTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/UpdateTemplate',
      request,
      metadata || {},
      methodDescriptor_KraftyService_UpdateTemplate,
      callback);
};


/**
 * @param {!proto.pb.Template} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Template>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.updateTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/UpdateTemplate',
      request,
      metadata || {},
      methodDescriptor_KraftyService_UpdateTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Template,
 *   !proto.pb.Template>}
 */
const methodDescriptor_KraftyService_DeleteTemplate = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/DeleteTemplate',
  grpc.web.MethodType.UNARY,
  template_pb.Template,
  template_pb.Template,
  /**
   * @param {!proto.pb.Template} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  template_pb.Template.deserializeBinary
);


/**
 * @param {!proto.pb.Template} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Template)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Template>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.deleteTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/DeleteTemplate',
      request,
      metadata || {},
      methodDescriptor_KraftyService_DeleteTemplate,
      callback);
};


/**
 * @param {!proto.pb.Template} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Template>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.deleteTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/DeleteTemplate',
      request,
      metadata || {},
      methodDescriptor_KraftyService_DeleteTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Template,
 *   !proto.pb.Template>}
 */
const methodDescriptor_KraftyService_ApproveTemplate = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/ApproveTemplate',
  grpc.web.MethodType.UNARY,
  template_pb.Template,
  template_pb.Template,
  /**
   * @param {!proto.pb.Template} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  template_pb.Template.deserializeBinary
);


/**
 * @param {!proto.pb.Template} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Template)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Template>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.approveTemplate =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/ApproveTemplate',
      request,
      metadata || {},
      methodDescriptor_KraftyService_ApproveTemplate,
      callback);
};


/**
 * @param {!proto.pb.Template} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Template>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.approveTemplate =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/ApproveTemplate',
      request,
      metadata || {},
      methodDescriptor_KraftyService_ApproveTemplate);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Image,
 *   !proto.pb.Image>}
 */
const methodDescriptor_KraftyService_FilterImages = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/FilterImages',
  grpc.web.MethodType.SERVER_STREAMING,
  image_pb.Image,
  image_pb.Image,
  /**
   * @param {!proto.pb.Image} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  image_pb.Image.deserializeBinary
);


/**
 * @param {!proto.pb.Image} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Image>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.filterImages =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterImages',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterImages);
};


/**
 * @param {!proto.pb.Image} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Image>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServicePromiseClient.prototype.filterImages =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterImages',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterImages);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Image,
 *   !proto.pb.Image>}
 */
const methodDescriptor_KraftyService_GetImage = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/GetImage',
  grpc.web.MethodType.UNARY,
  image_pb.Image,
  image_pb.Image,
  /**
   * @param {!proto.pb.Image} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  image_pb.Image.deserializeBinary
);


/**
 * @param {!proto.pb.Image} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Image)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Image>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.getImage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/GetImage',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetImage,
      callback);
};


/**
 * @param {!proto.pb.Image} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Image>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.getImage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/GetImage',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetImage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Image,
 *   !proto.pb.Image>}
 */
const methodDescriptor_KraftyService_NewImage = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/NewImage',
  grpc.web.MethodType.UNARY,
  image_pb.Image,
  image_pb.Image,
  /**
   * @param {!proto.pb.Image} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  image_pb.Image.deserializeBinary
);


/**
 * @param {!proto.pb.Image} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Image)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Image>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.newImage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/NewImage',
      request,
      metadata || {},
      methodDescriptor_KraftyService_NewImage,
      callback);
};


/**
 * @param {!proto.pb.Image} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Image>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.newImage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/NewImage',
      request,
      metadata || {},
      methodDescriptor_KraftyService_NewImage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Image,
 *   !proto.pb.Image>}
 */
const methodDescriptor_KraftyService_DeleteImage = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/DeleteImage',
  grpc.web.MethodType.UNARY,
  image_pb.Image,
  image_pb.Image,
  /**
   * @param {!proto.pb.Image} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  image_pb.Image.deserializeBinary
);


/**
 * @param {!proto.pb.Image} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Image)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Image>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.deleteImage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/DeleteImage',
      request,
      metadata || {},
      methodDescriptor_KraftyService_DeleteImage,
      callback);
};


/**
 * @param {!proto.pb.Image} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Image>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.deleteImage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/DeleteImage',
      request,
      metadata || {},
      methodDescriptor_KraftyService_DeleteImage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Image,
 *   !proto.pb.Image>}
 */
const methodDescriptor_KraftyService_WatchImages = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/WatchImages',
  grpc.web.MethodType.SERVER_STREAMING,
  image_pb.Image,
  image_pb.Image,
  /**
   * @param {!proto.pb.Image} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  image_pb.Image.deserializeBinary
);


/**
 * @param {!proto.pb.Image} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Image>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.watchImages =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/WatchImages',
      request,
      metadata || {},
      methodDescriptor_KraftyService_WatchImages);
};


/**
 * @param {!proto.pb.Image} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Image>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServicePromiseClient.prototype.watchImages =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/WatchImages',
      request,
      metadata || {},
      methodDescriptor_KraftyService_WatchImages);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Image,
 *   !proto.pb.Image>}
 */
const methodDescriptor_KraftyService_VerifyImage = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/VerifyImage',
  grpc.web.MethodType.UNARY,
  image_pb.Image,
  image_pb.Image,
  /**
   * @param {!proto.pb.Image} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  image_pb.Image.deserializeBinary
);


/**
 * @param {!proto.pb.Image} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.Image)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Image>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.verifyImage =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/VerifyImage',
      request,
      metadata || {},
      methodDescriptor_KraftyService_VerifyImage,
      callback);
};


/**
 * @param {!proto.pb.Image} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.Image>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.verifyImage =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/VerifyImage',
      request,
      metadata || {},
      methodDescriptor_KraftyService_VerifyImage);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.ImageCredentials,
 *   !proto.pb.ImageCredentials>}
 */
const methodDescriptor_KraftyService_FilterCredentials = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/FilterCredentials',
  grpc.web.MethodType.SERVER_STREAMING,
  image_pb.ImageCredentials,
  image_pb.ImageCredentials,
  /**
   * @param {!proto.pb.ImageCredentials} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  image_pb.ImageCredentials.deserializeBinary
);


/**
 * @param {!proto.pb.ImageCredentials} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.ImageCredentials>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.filterCredentials =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterCredentials',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterCredentials);
};


/**
 * @param {!proto.pb.ImageCredentials} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.ImageCredentials>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServicePromiseClient.prototype.filterCredentials =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterCredentials',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterCredentials);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.ImageCredentials,
 *   !proto.pb.ImageCredentials>}
 */
const methodDescriptor_KraftyService_GetCredentials = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/GetCredentials',
  grpc.web.MethodType.UNARY,
  image_pb.ImageCredentials,
  image_pb.ImageCredentials,
  /**
   * @param {!proto.pb.ImageCredentials} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  image_pb.ImageCredentials.deserializeBinary
);


/**
 * @param {!proto.pb.ImageCredentials} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.ImageCredentials)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.ImageCredentials>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.getCredentials =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/GetCredentials',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetCredentials,
      callback);
};


/**
 * @param {!proto.pb.ImageCredentials} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.ImageCredentials>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.getCredentials =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/GetCredentials',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetCredentials);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.ImageCredentials,
 *   !proto.pb.ImageCredentials>}
 */
const methodDescriptor_KraftyService_DeleteCredentials = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/DeleteCredentials',
  grpc.web.MethodType.UNARY,
  image_pb.ImageCredentials,
  image_pb.ImageCredentials,
  /**
   * @param {!proto.pb.ImageCredentials} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  image_pb.ImageCredentials.deserializeBinary
);


/**
 * @param {!proto.pb.ImageCredentials} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.ImageCredentials)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.ImageCredentials>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.deleteCredentials =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/DeleteCredentials',
      request,
      metadata || {},
      methodDescriptor_KraftyService_DeleteCredentials,
      callback);
};


/**
 * @param {!proto.pb.ImageCredentials} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.ImageCredentials>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.deleteCredentials =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/DeleteCredentials',
      request,
      metadata || {},
      methodDescriptor_KraftyService_DeleteCredentials);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Plant,
 *   !proto.pb.Plant>}
 */
const methodDescriptor_KraftyService_FilterPlants = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/FilterPlants',
  grpc.web.MethodType.SERVER_STREAMING,
  plant_pb.Plant,
  plant_pb.Plant,
  /**
   * @param {!proto.pb.Plant} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  plant_pb.Plant.deserializeBinary
);


/**
 * @param {!proto.pb.Plant} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Plant>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.filterPlants =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterPlants',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterPlants);
};


/**
 * @param {!proto.pb.Plant} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Plant>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServicePromiseClient.prototype.filterPlants =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterPlants',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterPlants);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Plant,
 *   !proto.pb.Plant>}
 */
const methodDescriptor_KraftyService_RefreshPlants = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/RefreshPlants',
  grpc.web.MethodType.SERVER_STREAMING,
  plant_pb.Plant,
  plant_pb.Plant,
  /**
   * @param {!proto.pb.Plant} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  plant_pb.Plant.deserializeBinary
);


/**
 * @param {!proto.pb.Plant} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Plant>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.refreshPlants =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/RefreshPlants',
      request,
      metadata || {},
      methodDescriptor_KraftyService_RefreshPlants);
};


/**
 * @param {!proto.pb.Plant} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Plant>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServicePromiseClient.prototype.refreshPlants =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/RefreshPlants',
      request,
      metadata || {},
      methodDescriptor_KraftyService_RefreshPlants);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.PlantInfo,
 *   !proto.pb.PlantInfo>}
 */
const methodDescriptor_KraftyService_GetPlantInfo = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/GetPlantInfo',
  grpc.web.MethodType.UNARY,
  plant_pb.PlantInfo,
  plant_pb.PlantInfo,
  /**
   * @param {!proto.pb.PlantInfo} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  plant_pb.PlantInfo.deserializeBinary
);


/**
 * @param {!proto.pb.PlantInfo} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.PlantInfo)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.PlantInfo>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.getPlantInfo =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/GetPlantInfo',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetPlantInfo,
      callback);
};


/**
 * @param {!proto.pb.PlantInfo} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.PlantInfo>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.getPlantInfo =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/GetPlantInfo',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetPlantInfo);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Upstream,
 *   !proto.pb.Upstream>}
 */
const methodDescriptor_KraftyService_FilterUpstream = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/FilterUpstream',
  grpc.web.MethodType.SERVER_STREAMING,
  upstream_pb.Upstream,
  upstream_pb.Upstream,
  /**
   * @param {!proto.pb.Upstream} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  upstream_pb.Upstream.deserializeBinary
);


/**
 * @param {!proto.pb.Upstream} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Upstream>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.filterUpstream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterUpstream',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterUpstream);
};


/**
 * @param {!proto.pb.Upstream} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Upstream>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServicePromiseClient.prototype.filterUpstream =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/FilterUpstream',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FilterUpstream);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.User,
 *   !proto.pb.User>}
 */
const methodDescriptor_KraftyService_FromContext = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/FromContext',
  grpc.web.MethodType.UNARY,
  user_pb.User,
  user_pb.User,
  /**
   * @param {!proto.pb.User} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  user_pb.User.deserializeBinary
);


/**
 * @param {!proto.pb.User} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.User)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.User>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.fromContext =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/FromContext',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FromContext,
      callback);
};


/**
 * @param {!proto.pb.User} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.User>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.fromContext =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/FromContext',
      request,
      metadata || {},
      methodDescriptor_KraftyService_FromContext);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.AgentState,
 *   !proto.pb.AgentState>}
 */
const methodDescriptor_KraftyService_GetAgentState = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/GetAgentState',
  grpc.web.MethodType.UNARY,
  agent_state_pb.AgentState,
  agent_state_pb.AgentState,
  /**
   * @param {!proto.pb.AgentState} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  agent_state_pb.AgentState.deserializeBinary
);


/**
 * @param {!proto.pb.AgentState} request The
 *     request proto
 * @param {?Object<string, string>} metadata User defined
 *     call metadata
 * @param {function(?grpc.web.RpcError, ?proto.pb.AgentState)}
 *     callback The callback function(error, response)
 * @return {!grpc.web.ClientReadableStream<!proto.pb.AgentState>|undefined}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.getAgentState =
    function(request, metadata, callback) {
  return this.client_.rpcCall(this.hostname_ +
      '/pb.KraftyService/GetAgentState',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetAgentState,
      callback);
};


/**
 * @param {!proto.pb.AgentState} request The
 *     request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!Promise<!proto.pb.AgentState>}
 *     Promise that resolves to the response
 */
proto.pb.KraftyServicePromiseClient.prototype.getAgentState =
    function(request, metadata) {
  return this.client_.unaryCall(this.hostname_ +
      '/pb.KraftyService/GetAgentState',
      request,
      metadata || {},
      methodDescriptor_KraftyService_GetAgentState);
};


/**
 * @const
 * @type {!grpc.web.MethodDescriptor<
 *   !proto.pb.Worker,
 *   !proto.pb.Worker>}
 */
const methodDescriptor_KraftyService_RegisterWorker = new grpc.web.MethodDescriptor(
  '/pb.KraftyService/RegisterWorker',
  grpc.web.MethodType.SERVER_STREAMING,
  worker_pb.Worker,
  worker_pb.Worker,
  /**
   * @param {!proto.pb.Worker} request
   * @return {!Uint8Array}
   */
  function(request) {
    return request.serializeBinary();
  },
  worker_pb.Worker.deserializeBinary
);


/**
 * @param {!proto.pb.Worker} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Worker>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServiceClient.prototype.registerWorker =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/RegisterWorker',
      request,
      metadata || {},
      methodDescriptor_KraftyService_RegisterWorker);
};


/**
 * @param {!proto.pb.Worker} request The request proto
 * @param {?Object<string, string>=} metadata User defined
 *     call metadata
 * @return {!grpc.web.ClientReadableStream<!proto.pb.Worker>}
 *     The XHR Node Readable Stream
 */
proto.pb.KraftyServicePromiseClient.prototype.registerWorker =
    function(request, metadata) {
  return this.client_.serverStreaming(this.hostname_ +
      '/pb.KraftyService/RegisterWorker',
      request,
      metadata || {},
      methodDescriptor_KraftyService_RegisterWorker);
};


module.exports = proto.pb;

